// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"23914016","926":"e96dbe7f"}[chunkId] + ".chunk.js";
};